export const headerEN = {
    "naslov": "FINA Validator",
    "o_nama": "About",
    "validateDoc": "Validator",
    "faq": "Frequently asked questions",
    "tos": "Terms and conditions",
    "guide": "Guide",
    "lang": "Language: ",
    "cookies_policy": "Cookies policy",
    "privacy_policy": "Privacy policy"
};